import AntSpace from 'antd-core/es/space';
import styled, { css } from 'styled-components';
import { antMigrationPrefix } from 'constants/ant';
import { ISpace } from './types';

export const StyledSpace = styled(AntSpace).attrs({
  prefixCls: antMigrationPrefix.space,
})<ISpace>`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  width: ${({ width }) => (width ? width : '100%')};

  ${({ $nowrap }) =>
    $nowrap &&
    css`
      white-space: nowrap;
    `}

  ${({ $hidden }) =>
    $hidden &&
    css`
      overflow: hidden;
    `}


  ${({ $wrap }) =>
    $wrap &&
    css`
      display: flex;
      flex-wrap: wrap;

      & > .ant-space-item {
        margin-bottom: 8px;
      }
    `}

  & > .ant-space-item {
    ${({ $fullItems }) =>
      $fullItems &&
      css`
        width: 100%;
      `}

    ${({ $center }) =>
      $center &&
      css`
        display: flex;
        align-items: center;
      `}
  }

  ${({ $resetLineHeight }) =>
    $resetLineHeight &&
    css`
      line-height: 1;

      & > .ant-space-item {
        line-height: 1;
      }
    `}

  ${({ lineHeight }) =>
    lineHeight &&
    css`
      & > .ant-space-item {
        line-height: ${lineHeight}px;
      }
    `}

  ${({ $justifyContent }) =>
    $justifyContent &&
    css`
      justify-content: ${$justifyContent};
    `}

    ${({ $alignItems }) =>
    $alignItems &&
    css`
      align-items: ${$alignItems};
    `}
`;

export const HeaderSpace = styled(StyledSpace)`
  display: flex;
  justify-content: space-between;
`;
